import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@Component({
  selector: 'app-help-page',
  standalone: true,
  imports: [CommonModule, CollapseModule],
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss']
})
export class HelpPageComponent {
  helpItems = [
    {
      title: 'Navigacija po tržnici',
      text: `<ol>
      <li>Gumbi za navigacijo do tržnice, seznama ponudnikov, koledarja in pomoči.</li>
      <li>Gumbi za prijavo, izpis, registracijo kmetije, profil kmetije in osebni profil.</li>
      <li>Iskalno okno za filtriranje po tipu (zelenjava, meso, mlečni izdelki, ostalo).</li>
      <li>Iskanje izdelkov po imenu.</li>
      <li>Oceni produkt ali preberi ostale ocene.</li>
      <li>Gumb za kontaktiranje lastnika o izdelku.</li>
    </ol>`
    ,
      expanded: false,
      images: [
        '../../assets/images/help/trznica/market.png',
      ]
    },
    {
      title: 'Navigacija po profilu kmetije',
      text: `<ol>
  <li>Gumba za naročanje na kmetijo in pošiljanje e-pošte lastniku.</li>
  <li>Navigacijska vrstica.</li>
  <li>Gumb za urejanje uporabniških podatkov.</li>
  <li>Gumb za dodajanje slike.</li>
  <li>S klikom na sliko jo izberemo.</li>
  <li>Izbrano sliko z gumbom "Izbriši izbrano sliko" izbrišemo.</li>
  <li>Gumba za urejanje ali odstranjevanje zaposlenih.</li>
  <li>Gumb za dodajanje zaposlenega.</li>
  <li>Gumbi za dodajanje, urejanje ali ocenjevanje produktov.</li>
  <li>Gumb za dodajanje izdelka.</li>
  <li>Podatki o naročniku, lahko ga tudi odstranite.</li>
  <li>Podatki o sporočilu uporabnikov, gumba za podrobnosti in izbris.</li>
</ol>
`,
      images: [
        '../../assets/images/help/farmProfile/osebniPod.png',
        '../../assets/images/help/farmProfile/galerija.png',
        '../../assets/images/help/farmProfile/zaposleni.png',
        '../../assets/images/help/farmProfile/produkti.png',
        '../../assets/images/help/farmProfile/statistike.png',
      ],
      expanded: false
    },
    {
      title: 'Prijava in registracija',
      text: `<ol>
            <li>Gumb za prijavo se nahaja v zgornjem desnem kotu.</li>
            <li>Vnesite uporabniško ime.</li>
            <li>Vnesite geslo.</li>
            <li>Kliknite za prijavo.</li>
            <li>Če nimate računa, vas ta povezava</a> pripelje do registracije.</li>
            <li>Vnesite uporabniško ime, geslo, e-poštni naslov, naslov in telefon.</li>
            <li>Kliknite za registracijo, na e-pošto boste prejeli potrditveno sporočilo.</li>
            <li>V kolikor že imate račun, vas ta povezava</a> pripelje na prijavo.</li>
          </ol>`,
      images: [
        '../../assets/images/help/registration/gumb.png',
        '../../assets/images/help/registration/prijava.png',
        '../../assets/images/help/registration/registracija.png',
      ],
      expanded: false
    },
    {
      title: 'Registracija kmetije',
      text: `<ol>
  <li>Gumb, ki vas pripelje na stran za registracijo kmetije. Samo prijavljeni uporabniki vidijo ta gumb.</li>
  <li>Vnesi podatke o kmetiji: Ime, naslov, telefon, e-poštni naslov in opis.</li>
  <li>Kliknite na zemljevid, da določite lokacijo kmetije.</li>
  <li>Nadaljevanje registracije.</li>
  <li>Vnos podatkov zaposlenih, vnesti morate najmanj enega zaposlenega. Vnesite ime, priimek in opis.</li>
  <li>Gumb za dodajanje več zaposlenih.</li>
  <li>Navigacijski gumbi za nadaljevanje registracije ali vrnitev na prejšnji korak.</li>
  <li>Vnos podatkov za produkte. Dodati morate najmanj en produkt, slike lahko dodajate kasneje. Vpišite ime, opis in izberite tip.</li>
  <li>Gumb za dodajanje izdelka.</li>
  <li>Navigacijski gumbi za dokončanje registracije ali vrnitev na prejšnji korak.</li>
</ol>
`,
      images: [
        '../../assets/images/help/farmRegister/gumb.png',
        '../../assets/images/help/farmRegister/ena.png',
        '../../assets/images/help/farmRegister/dva.png',
        '../../assets/images/help/farmRegister/tri.png',
      ]
    },
    {
      title: 'Koledar',
      text: `<ol>
      <li>Za dodajanje dogodka najprej izberemo barvo.</li>
      <li>Nato izberemo datum ali z vlečenjem več dni. To bo odprlo okno za vpis imena in podrobnosti.</li>
      <li>Za daljšanje in krajšanje dogodka z miško primemo rob in ga vlečemo. Za izbris kliknemo na dogodek.</li>
      <li>S klikom na "Vsi dogodki" pregledamo seznam vseh dogodkov.</li>
    </ol>`
    ,
      images: [
        '../../assets/images/help/calendar/koledar.png'
      ],
      expanded: false
    },
    {
      title: 'Kontaktiraj podporo',
      text: '<p>Za pomoč pišite na podpora@gmail.com</p>',
      images: [
      ],
      expanded: false
    }
  ];

  toggleExpand(index: number): void {
    this.helpItems[index].expanded = !this.helpItems[index].expanded;
  }
}
